import styled from 'styled-components';

import SpinnerSVG from '../../assets/icons/line-spinner.svg';
import { colors } from '../constants';
import { bezier } from '../utilities/css-helpers';

// rotating line loading spinner
const LineSpinner = styled(SpinnerSVG)`
  animation-name: spin;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  @-moz-keyframes spin {
    from {
      -moz-transform: rotate(0deg);
    }
    to {
      -moz-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  fill: ${colors.UI_SECONDARY_ACTION};
  ${bezier};
`;
LineSpinner.displayName = 'LineSpinner';

export default LineSpinner;
